
<template>
    
        <mars-view :class="componentsFrom === 'case-detail' ? 'inline-flex-box-inline' : 'inline-flex-box'"><mars-view v-if="componentsFrom === 'home' && lawyerInfo && (lawyerInfo.practice_year || lawyerInfo.answer_count)" class="carefull-lawyer-item-subtitle">
        {{ lawyerInfo.practice_year ? lawyerInfo.practice_year : '' }}
        {{ lawyerInfo.answer_count ? `服务${ lawyerInfo.answer_count }人` : '' }}
    </mars-view><mars-view v-if="componentsFrom === 'local-card' && lawyerInfo && (lawyerInfo.practice_year || lawyerInfo.answer_count)" class="info" :class="'info-' + fontSizeSetting"><mars-view v-if="lawyerInfo.practice_year" class="years">{{ lawyerInfo.practice_year }}</mars-view><mars-view v-if="lawyerInfo.answer_count" class="firm">服务{{ lawyerInfo.answer_count }}人</mars-view></mars-view><mars-view v-if="componentsFrom === 'local-card-normal' && lawyerInfo && (lawyerInfo.practice_year || lawyerInfo.practice_company)" class="lawyer-right-time-firm"><mars-view v-if="lawyerInfo.practice_year" class="lawyer-right-time">
            {{ lawyerInfo.practice_year }}
        </mars-view><mars-view class="lawyer-right-firm">
            {{ lawyerInfo.practice_company }}
        </mars-view></mars-view><mars-text v-if="componentsFrom === 'case-detail' && lawyerInfo.year && lawyerInfo.show_register_years" class="lawyer-info-years">执业{{ lawyerInfo.year }}年</mars-text></mars-view>
    
</template>

<script>
/* globals getApp, Page, swan */

export default {
  props: {
    componentsFrom: {
      type: String,
      default: ''
    },
    lawyerInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    fontSizeSetting: {
      type: Number,
      default: 0
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {}
};
</script>

<style scoped>
.inline-flex-box {
  width: 100%;
  display: inline-flex;
}
.inline-flex-box-inline {
  display: inline-flex;
}
.carefull-lawyer-item-subtitle {
  width: 100%;
  font-size: 13px;
  color: #50525c;
  line-height: 1;
  padding: 0.1rem 0.09rem 0 0.08rem;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: PingFang SC;
}
.info {
  display: flex;
}
.info .years {
  margin-right: 0.08rem;
  flex-shrink: 0;
}
.info .firm {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.info {
  margin-top: 0.1rem;
  line-height: 0.15rem;
  font-size: 0.14rem;
  color: #50525c;
  width: 2.3rem;
}
.info-5 {
  margin-top: 0;
  font-size: 11px !important;
}
.lawyer-right-time-firm {
  width: calc(100% - 19.46vw);
  font-size: 0.14rem;
  line-height: 0.15rem;
  color: #50525c;
  display: flex;
  margin-top: 0.07rem;
  white-space: nowrap;
  min-width: 0;
}
.lawyer-right-time-firm .lawyer-right-time {
  margin-right: 8px;
  flex-shrink: 0;
}
.lawyer-right-time-firm .lawyer-right-firm {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.lawyer-info-years {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.13rem;
  color: #848691;
  line-height: 1;
  vertical-align: bottom;
  margin-left: 0.08rem;
}

</style>
